import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import { twJoin } from 'tailwind-merge';
import { ColorVariantType } from 'types/product';

type ColorVariantsItemProps = {
    currentVariantUuid: string;
    variant: ColorVariantType;
};

export const ColorVariantsItem: FC<ColorVariantsItemProps> = ({ currentVariantUuid, variant }) => {
    return (
        <ExtendedNextLink
            type="product"
            href={`/${variant.slug}`}
            className={twJoin(
                'relative mx-1 mb-2 flex w-[107px] flex-shrink-0 flex-col items-center justify-start gap-1 rounded-md border border-green bg-white p-2 text-center text-small font-medium text-primary no-underline',
                'hover:text-green hover:no-underline hover:shadow-[0_0_0_3px_#00806050]',
                currentVariantUuid === variant.uuid && 'border-green text-green shadow-[0_0_0_3px_#00806050]',
            )}
            key={variant.name}
        >
            <>
                <Image src={variant.image ?? null} alt={variant.name} width="80" height="80" className="h-20 w-20" />
                {variant.name}
            </>
        </ExtendedNextLink>
    );
};
